// import breakpoints from "../breakpoints";

// NOTE: this affects DatePicker too.
export default {
  // root: {
  //   minHeight: 0,
  // },
  // dense: {
  //   minHeight: 0,
  // },
  // gutters: {
  //   [breakpoints.up("sm")]: {
  //     paddingLeft: "0.2rem", //"0rem",
  //     paddingRight: "0.2rem" //"1rem",
  //   },
  //   [breakpoints.down("sm")]: {
  //     paddingLeft: "0.5rem", //"1rem",
  //     paddingRight: "0.5rem" //"1rem",
  //   },
  // },
};
